import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import placeApi from '@src/services/api/place';
import { useEffect, useMemo, useRef, useState } from 'react';

import styled, { css } from 'styled-components';
import dayjs, { Dayjs } from 'dayjs';
import { TimeTableType } from '@src/types/place';
import { MenuItem, Select } from '@mui/material';
import Button from '@src/components/ui/atoms/button';
import { getAccessToken } from '@src/services/storage/cookies';
import { parseToken } from '@utils/index';
import Input from '@src/components/ui/atoms/input';

const Container = styled.div`
  // padding: 30px 12px;
  // >div {
  //   > div {
  //     display: grid;
  //     grid-template-columns: auto 1fr;
  //     gap: 20px;
  //   }
  // }
`;

const DateWrap = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;

const TimeTableWrap = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  p {
    margin-bottom: 10px;
  }
  >div: first-of-type {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    > div {
      max-width: 100px;
      font-size: 13px;
      text-align: center;
      position: relative;
    }
  }
`;

const TimeButton = styled.button<{ selected: boolean }>`
  width: 100px;
  background-color: #3f4a9950;
  width: 100%;
  height: 30px;
  border: 0;
  position: relative;
  margin-bottom: 3px;
  &:disabled,
  &[disabled] {
    background-color: #00000030;
  }
  ${props =>
    props.selected &&
    css`
      &::after {
        content: '';
        width: 100%;
        height: calc(100% - 5px);
        position: absolute;
        top: 0;
        left: 0;
        background-color: #3f4a9980;
      }
    `}
`;

const ButtonWrap = styled.div`
  display: flex;
  justify-content: end;
`;

const BookingInfoWrap = styled.div`
  margin: 30px 0;
  > p {
    margin-bottom: 15px;
  }
  > div {
    display: grid;
    grid-template-columns: 100px auto;
    align-items: center;
    gap: 10px 20px;
    span {
      color: #3d3d3d;
      font-size: 13px;
    }
  }
`;

type PropTypes = {
  itemId: string;
};

export default function ScheduleList({ itemId }: PropTypes) {
  const [dateInfo, setDateInfo] = useState<{ startDate: Dayjs; endDate: Dayjs }>();
  const [selectedDate, setSelectedDate] = useState<Dayjs>();
  const referenceDate = useMemo(() => dateInfo && dayjs(dateInfo.startDate), [dateInfo]);
  const [timeTable, setTimeTable] = useState<TimeTableType[]>();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [selectedCount, setSelectedCount] = useState<number>(-1);
  const [delay, setDelay] = useState<number>(0);
  const userId = useRef('');
  const [isAdmin, setIsAdmin] = useState(false);
  const availableTimes = useMemo(
    () =>
      timeTable
        ?.map(({ id, available, unit_start_time }, index) => ({ id, available, unit_start_time, index }))
        .filter(time => time.available)
        .map(time => ({
          id: time.id,
          label: dayjs(time.unit_start_time).tz('Asia/Seoul').format('HH:mm'),
          index: time.index,
        })),
    [timeTable],
  );
  const displayTimes = useMemo(() => {
    if (!timeTable) return [];
    return timeTable.filter(time => {
      if (dayjs(time.unit_start_time).isBefore(dayjs(time.unit_start_time).hour(5).minute(59))) {
        return false;
      }
      if (dayjs(time.unit_start_time).isAfter(dayjs(time.unit_start_time).hour(22).minute(0))) {
        return false;
      }
      return true;
    });
  }, [timeTable]);

  const availableCount = useMemo(() => {
    if (!timeTable || selectedIndex < 0 || !availableTimes?.length) {
      return [];
    }
    const cnt = timeTable?.slice(availableTimes[selectedIndex].index).findIndex(time => !time.available) || -1;

    return Array.from({ length: cnt > 4 ? 4 : cnt }, (_, i) => i + 1);
  }, [timeTable, selectedIndex, availableTimes]);

  const selectedTimes = useMemo(() => {
    if (selectedIndex < 0 || selectedCount < 0 || !timeTable || !availableTimes) {
      return [];
    }
    const start = availableTimes[selectedIndex].index;
    const end = start + selectedCount;
    return timeTable?.slice(start, end)?.map(time => time.id);
  }, [selectedIndex, selectedCount, timeTable, availableTimes]);

  async function getStartEndDate() {
    if (!itemId) {
      return;
    }
    const { data } = await placeApi.getScheduleDate(itemId);
    const endDate = dayjs(new Date(data.end_date));
    const startDate = endDate.set('date', 1);
    setDateInfo({ startDate, endDate });
  }

  async function getDaySchedule(date: Dayjs | null) {
    if (!date) return;
    setSelectedDate(date);
    const { data } = await placeApi.getScheduleList(itemId || '', date.format('YYYY-MM-DD'));
    setTimeTable(data);
  }

  async function handleRequest() {
    if (!name || !phone || !email) {
      alert('check reservation info');
      return;
    }
    if (selectedCount < 0 || selectedIndex < 0 || !timeTable || !availableTimes) {
      alert('select schedule');
      return;
    }
    const startIndex = availableTimes[selectedIndex].index;
    const targetTimes = timeTable?.slice(startIndex, selectedCount + startIndex);
    if (!targetTimes?.length) {
      return;
    }

    const priceJson = targetTimes.map(time => ({
      [dayjs(time.unit_start_time).tz('Asia/Seoul').format()]: time.price,
    }));
    const price = targetTimes.reduce((pre, curr) => pre + curr.price, 0);
    const start_date_time = dayjs(timeTable[startIndex].unit_start_time).tz('Asia/Seoul').format();
    console.log(start_date_time);
    const end_date_time = dayjs(
      new Date(timeTable[startIndex].unit_start_time).getTime() +
        targetTimes.reduce((pre, curr) => pre + curr.duration, 0) * 60 * 1000,
    )
      .tz('Asia/Seoul')
      .format();
    const hour_bit = timeTable.map(({ id }) => (selectedTimes.some(time => time === id) ? '1' : '0')).join('');

    const { code } = await placeApi.requestBooking({
      request_user_id: userId.current,
      price,
      biz_item_daily_price_json: JSON.stringify(priceJson),
      name,
      phone,
      email,
      item_id: itemId,
      start_date_time,
      end_date_time,
      hour_bit,
      delay: isAdmin ? delay : undefined,
    });
    if (code === 200) {
      alert('success');
      setSelectedIndex(-1);
      setSelectedCount(-1);
      return;
    }
    alert('fail');
  }

  useEffect(() => {
    setSelectedCount(-1);
  }, [selectedIndex]);

  useEffect(() => {
    setSelectedIndex(-1);
  }, [timeTable]);

  useEffect(() => {
    const token = getAccessToken();

    const info = parseToken(token.access);
    setName(info.name);
    setPhone(info.cellphone_number);
    setEmail(info.email);
    userId.current = info.id;
    setIsAdmin(info.is_admin);
  }, []);

  useEffect(() => {
    getStartEndDate();
    setSelectedDate(undefined);
    selectedDate && getDaySchedule(selectedDate);
  }, [itemId]);

  return (
    <Container key={itemId}>
      <div>
        <DateWrap>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              key={new Date().getTime()}
              value={selectedDate}
              referenceDate={referenceDate}
              timezone="Asia/Seoul"
              autoFocus={false}
              disableHighlightToday={true}
              onChange={getDaySchedule}
              closeOnSelect={true}
              slots={{
                toolbar: () => <></>,
                actionBar: () => <></>,
              }}
            ></MobileDatePicker>
            {/* <DateCalendar
              referenceDate={referenceDate}
              minDate={dateInfo.startDate}
              maxDate={dateInfo.endDate}
              timezone="Asia/Seoul"
              autoFocus={false}
              disableHighlightToday={true}
              onChange={getDaySchedule}
            /> */}
          </LocalizationProvider>
        </DateWrap>
        {timeTable && (
          <TimeTableWrap>
            <div>
              {displayTimes?.map(time => (
                <div key={time.id}>
                  <TimeButton
                    disabled={!time.available}
                    selected={selectedTimes.some(key => key === time.id)}
                  ></TimeButton>
                  {/* <p>{time.unit_start_time}</p> */}
                  <span>{dayjs(time.unit_start_time).tz('Asia/Seoul').format('HH:mm')}</span>
                </div>
              ))}
            </div>
            {availableTimes?.length ? (
              <div>
                <p>시작시간</p>
                <Select
                  value={selectedIndex}
                  style={{ width: 200, marginRight: 20 }}
                  onChange={event => setSelectedIndex(parseInt(event.target.value as string))}
                >
                  {availableTimes?.map((time, index) => (
                    <MenuItem key={time.id} value={index}>
                      {time.label}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  value={selectedCount}
                  style={{ width: 200 }}
                  onChange={event => setSelectedCount(parseInt(event.target.value as string))}
                >
                  {availableCount.map(time => (
                    <MenuItem key={time} value={time}>
                      {time}시간
                    </MenuItem>
                  ))}
                </Select>
              </div>
            ) : (
              <></>
            )}
          </TimeTableWrap>
        )}
        <BookingInfoWrap>
          <p>예약자 정보</p>
          <div>
            <span>이름</span>
            <div>
              <Input value={name} onChange={setName} />
            </div>
            <span>전화번호</span>
            <div>
              <Input value={phone} onChange={setPhone} />
            </div>
            <span>이메일</span>
            <div>
              <Input value={email} onChange={setEmail} />
            </div>
            {isAdmin ? (
              <>
                <span>Delay</span>
                <div>
                  <Input value={delay.toString()} onChange={val => setDelay(parseInt(val))} type="number" />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </BookingInfoWrap>
        <ButtonWrap>
          <Button onClick={handleRequest}>Request</Button>
        </ButtonWrap>
      </div>
    </Container>
  );
}

// 안재준 id: atene_1  pw: atene001
// 박은일 id: atene_2  pw: atene002
// 김다슬 id: atene_3  pw: atene003
// 권민재 id: atene_4  pw: atene004
// 이재우 id: atene_5  pw: atene005
// 이창훈 id: atene_6  pw: atene006
// 최경민 id: atene_7  pw: atene007
